import React from "react";

export const IconStar = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 23"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m11.994 20.26v1.9902m-9.0475-8.557-1.8808 0.6474m5.338-11.328-1.1691-1.611m15.81 12.312 1.8808 0.6474m-5.2723-11.304 1.1966-1.5904m-6.0467 0.33497 2.1144 4.2878c0.1315 0.26621 0.3858 0.45088 0.6793 0.49411l4.7284 0.68762c0.7401 0.10805 1.0356 1.0177 0.4996 1.5393l-3.4219 3.3379c-0.213 0.2073-0.3092 0.5059-0.2591 0.7986l0.8079 4.7132c0.1266 0.7377-0.6469 1.2996-1.3085 0.9519l-4.2298-2.225c-0.2631-0.1385-0.5772-0.1385-0.8393 0l-4.2297 2.225c-0.66161 0.3477-1.4351-0.2142-1.3085-0.9519l0.80787-4.7132c0.05006-0.2927-0.04712-0.5913-0.25915-0.7986l-3.4209-3.3369c-0.53498-0.52259-0.23952-1.4322 0.49964-1.5393l4.7284-0.68762c0.2935-0.04224 0.54774-0.22692 0.67927-0.49411l2.1144-4.2878c0.3308-0.6719 1.2869-0.6719 1.6177-9.8e-4z"
      stroke="#000"
      strokeMiterlimit="10"
    />
  </svg>
);

export default IconStar;
